import regalo_rojo from "../../img/regalo_rojo.svg";

export const tables_link = window.location.href.includes("hola") ? "http://street_giving.test/myTable" : "https://savethechildrenmx.org/myTable"

var items = null
var base = window.location.href.includes("hola") ? "http://street_giving.test" : "https://savethechildrenmx.org"
var bines = null
var errors_counter = 0
export var links = ["/", "/gifts", "/donors", "/cart", "/payment"];


function formatCurrency(amount,currency = "MXN") {
    return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: currency,
    }).format(amount);
}

const getItems = () => {
    items = localStorage.getItem("items")
    if (items === null) {
        items = []
    } else {
        items = JSON.parse(items)
    }
}

const updateItems = () => {
    items = JSON.stringify(items)
    localStorage.setItem("items", items)
}

export const updateCartNumber = () => {
    getItems()
    document.querySelector(".menu .items .items").textContent = items.length
}

const updateCardColor = (number) => {

    if (number.length >= 6) {
        bines = JSON.parse(localStorage.getItem('bines'))
        let data = bines.filter(bin => bin.id === Number(number))

        document.querySelector(".card").classList.remove("MASTERCARD")
        document.querySelector(".card").classList.remove("generic")
        document.querySelector(".card").classList.remove("VISA")
        document.querySelector(".card").classList.remove("AMERICAN_EXPRESS")

        if (data.length > 0) {
            document.querySelector(".card").classList.add(data[0].franquicia)
            document.querySelector(".bank_name").textContent = data[0].banco

            document.getElementById("banco").value = data[0].banco
            document.getElementById("producto").value = data[0].producto
            document.getElementById("franquicia").value = data[0].franquicia
            document.getElementById("tipo").value = data[0].tipo
            if (data[0].banco.length > 20) {
                document.querySelector(".bank_name").style.fontSize = "12px"
            }
        } else {
            document.querySelector(".bank_name").textContent = "Desconocido"
            document.querySelector(".card").classList.add("generic")
            document.getElementById("banco").value = ""
            document.getElementById("producto").value = ""
            document.getElementById("franquicia").value = ""
            document.getElementById("tipo").value = ""
        }
    }
}

export const addToCart = (evt) => {
    getItems()

    var item = evt.target;
    while (!item.classList.contains("gift-container")) {
        item = item.parentElement
    }

    var producto = {
        "image": item.querySelector("img").src,
        "description": item.querySelector(".desc").textContent,
        "amount": item.querySelector(".amount").getAttribute("amount"),
        "cantidad": 1,
        "p_id": item.querySelector(".cart").getAttribute("p_id")
    }

    items.push(producto)
    updateItems()

    item.querySelector(".cart").classList.add("d-none")
    item.querySelector(".delete-cart").classList.remove("d-none")
    updateCartNumber()
}

export const deleteToCart = (evt) => {
    getItems()

    var item = evt.target;
    while (!item.classList.contains("gift-container")) {
        item = item.parentElement
    }

    items = items.filter(element => element.description !== item.querySelector(".desc").textContent)

    updateItems()

    item.querySelector(".cart").classList.remove("d-none")
    item.querySelector(".delete-cart").classList.add("d-none")

    updateCartNumber()
}

export const incrementarCantidad = (evt) => {
    getItems()
    var plus = evt.target
    var cantidad = Number(plus.parentElement.querySelector("input").value)
    var description = evt.target.parentElement.parentElement.parentElement.querySelector(".description").textContent
    var subtotal = evt.target.parentElement.parentElement.parentElement.querySelector(".element-description-subtotal")

    plus.parentElement.querySelector("input").value = cantidad + 1

    var currencies = null
    var moneda = null
    if (getQueryParam("currency") !== null){
        currencies = localStorage.getItem("donors")
        currencies = JSON.parse(currencies)
        currencies = currencies.currencies

        moneda = currencies.filter(c => c.Codigo.localeCompare(getQueryParam("currency")) === 0)
        moneda = moneda[0]

    }

    var item = items.filter(producto => producto.description.localeCompare(description) === 0)
    item = item[0]
    item.cantidad = cantidad + 1

    items = items.filter(producto => producto.description.localeCompare(description) !== 0)
    items.push(item)

    if (getQueryParam("currency") != null){
        subtotal.textContent = "Subtotal: " + formatCurrency((cantidad + 1) * plus.getAttribute("amount"))  +" "+ moneda.Codigo
    }else{
        subtotal.textContent = "Subtotal: " + formatCurrency((cantidad + 1) * plus.getAttribute("amount"))
    }


    updateItems()
    calculateSubtotal()
}

export const decrementarCantidad = (evt) => {
    getItems()
    var minus = evt.target
    var cantidad = Number(minus.parentElement.querySelector("input").value)
    var description = evt.target.parentElement.parentElement.parentElement.querySelector(".description").textContent
    var subtotal = evt.target.parentElement.parentElement.parentElement.querySelector(".element-description-subtotal")

    minus.parentElement.querySelector("input").value = cantidad - 1

    var currencies = null
    var moneda = null
    if (getQueryParam("currency") !== null){
        currencies = localStorage.getItem("donors")
        currencies = JSON.parse(currencies)
        currencies = currencies.currencies

        moneda = currencies.filter(c => c.Codigo.localeCompare(getQueryParam("currency")) === 0)
        moneda = moneda[0]

    }

    var item = items.filter(producto => producto.description.localeCompare(description) === 0)
    item = item[0]
    item.cantidad = cantidad - 1

    items = items.filter(producto => producto.description.localeCompare(description) !== 0)
    items.push(item)

    if (getQueryParam("currency") !== null){
        subtotal.textContent = "Subtotal: " + formatCurrency((cantidad - 1) * minus.getAttribute("amount")) + " " + moneda.Codigo
    }else{
        subtotal.textContent = "Subtotal: " + formatCurrency((cantidad - 1) * minus.getAttribute("amount"))
    }


    updateItems()
    calculateSubtotal()
}

export const eliminarProducto = (evt) => {
    getItems()
    var elemento = evt.target

    while (!elemento.classList.contains("product")) {
        elemento = elemento.parentElement
    }

    var description = elemento.querySelector(".description").textContent

    items = items.filter(producto => producto.description.localeCompare(description) !== 0)
    updateItems()
    calculateSubtotal()
    updateCartNumber()

    elemento.remove()
}

export const calculateSubtotal = () => {
    getItems()

    let subtotal = 0

    items.forEach(element => {
        subtotal += (element.amount * element.cantidad)
    })

    var currencies = null
    var moneda = null
    if (getQueryParam("currency") !== null){
        currencies = localStorage.getItem("donors")
        currencies = JSON.parse(currencies)
        currencies = currencies.currencies

        moneda = currencies.filter(c => c.Codigo.localeCompare(getQueryParam("currency")) === 0)
        moneda = moneda[0]

        document.querySelector(".cart_container .subtotal").innerHTML = "Subtotal <br> " + formatCurrency(subtotal) + " " + moneda.Codigo
    }else{
        document.querySelector(".cart_container .subtotal").innerHTML = "Subtotal <br> " + formatCurrency(subtotal)
    }
}

export const createElements = () => {
    getItems()
    var container = document.querySelector(".cart-items")

    let total_counter = 0

    if (items.length > 0) {
        document.querySelector(".cart-items").innerHTML = ""
    }

    var currencies = null
    var moneda = null
    if (getQueryParam("currency") !== null){
        currencies = localStorage.getItem("donors")
        currencies = JSON.parse(currencies)
        currencies = currencies.currencies

        moneda = currencies.filter(c => c.Codigo.localeCompare(getQueryParam("currency")) === 0)
        moneda = moneda[0]

    }

    items.forEach(element => {
        var product = document.createElement("div")
        product.classList.add("product")

        var image = document.createElement("img")
        image.src = element.image

        var product_tools = document.createElement("div")
        product_tools.classList.add("product_tools")

        var description = document.createElement("div")
        description.classList.add("description")
        description.textContent = element.description

        var element_description_subtotal = document.createElement("div")
        element_description_subtotal.classList.add("element-description-subtotal")

        if (getQueryParam("currency") !== null){
            element_description_subtotal.textContent = "Subtotal: " + (formatCurrency(element.amount * element.cantidad)) +" "+ moneda.Codigo
        }else{
            element_description_subtotal.textContent = "Subtotal: " + (formatCurrency(element.amount))
        }

        var tools = document.createElement("div")
        tools.classList.add("tools")

        var counter = document.createElement("div")
        counter.classList.add("counter")

        var minus = document.createElement("button")
        minus.classList.add("minus")
        minus.setAttribute("amount", element.amount)
        minus.textContent = "-"
        minus.addEventListener('click', decrementarCantidad)

        var input = document.createElement("input")
        input.classList.add("cantidad")
        input.value = element.cantidad

        var plus = document.createElement("button")
        plus.classList.add("plus")
        plus.textContent = "+"
        plus.setAttribute("amount", element.amount)
        plus.addEventListener('click', incrementarCantidad)

        var delete_button = document.createElement("button")
        delete_button.classList.add("delete")
        delete_button.textContent = "Eliminar"
        delete_button.addEventListener('click', eliminarProducto)


        counter.appendChild(minus)
        counter.appendChild(input)
        counter.appendChild(plus)

        tools.appendChild(counter)
        tools.appendChild(delete_button)

        product_tools.appendChild(description)
        product_tools.appendChild(element_description_subtotal)
        product_tools.appendChild(tools)

        product.appendChild(image)
        product.appendChild(product_tools)
        container.appendChild(product)

        total_counter = total_counter + (element.amount * element.cantidad)
    })


    if (total_counter === 0) {
        document.querySelector(".pago").classList.add("d-none")
        document.querySelector(".gifts").classList.remove("d-none")
    }
    if (getQueryParam("currency") !== null){
        document.querySelector(".subtotal").innerHTML = "Subtotal <br>" + formatCurrency(total_counter) + " " + moneda.Codigo
    }else{
        document.querySelector(".subtotal").innerHTML = "Subtotal <br>" + formatCurrency(total_counter)
    }

}

const valid = (element) => {
    element.classList.add("is-valid")
    element.classList.remove("is-invalid")
}

const invalid = (element) => {
    element.classList.remove("is-valid")
    element.classList.add("is-invalid")
}

export const verifyStep = (input) => {
    var element = input

    while (!element.classList.contains("step-1") && !element.classList.contains("step-2") && !element.classList.contains("step-3")) {
        element = element.parentElement
    }

    var flag = true

    element.querySelectorAll(".data").forEach(item => {
        if (item.classList.contains("is-invalid") || !item.classList.contains("is-valid")) {
            flag = false
        }

    })

    if (flag) {
        enableButton(element.querySelector("button"))
    } else {
        disabledButton(element.querySelector("button"))
    }

}

export const handleNombre = (evt) => {
    var input = evt.target
    var regex = new RegExp("^[a-zA-ZñÑÁÉÍÓÚáéíóú ']{3,}$")

    if (regex.test(input.value)) {
        valid(input.parentElement)
    } else {
        invalid(input.parentElement)
    }

    verifyStep(input)
}

export const handleEmail = (evt) => {
    var input = evt.target
    var regex = new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")

    if (regex.test(input.value)) {
        valid(input.parentElement)
    } else {
        invalid(input.parentElement)
    }

    verifyStep(input)
}

export const handlePhone = (evt) => {
    var input = evt.target
    var regex = new RegExp("^[0-9]{10}$")

    if (regex.test(input.value)) {
        valid(input.parentElement)
    } else {
        invalid(input.parentElement)
    }
    verifyStep(input)
}

export const handleTitular = (evt) => {
    var input = evt.target
    var regex = new RegExp("^[a-zA-ZñÑÁÉÍÓÚáéíóú ']{3,}$")

    if (regex.test(input.value)) {
        valid(input.parentElement)
    } else {
        invalid(input.parentElement)
    }

    verifyStep(input)
    document.querySelector(".extras .titular").textContent = input.value
}

export const handleTarjeta = (evt) => {
    var input = evt.target
    var array = input.value.split("")
    var number = input.value.substring(0, 6)
    var regex = new RegExp("^[0-9]{15,16}$")

    document.querySelectorAll(".card-number div").forEach(element => {
        element.textContent = "-"
    })

    if (regex.test(input.value)) {
        valid(input.parentElement)
    } else {
        invalid(input.parentElement)
    }

    verifyStep(input)

    array.forEach((element, index) => {
        if (input.value.length <= 16) {
            document.querySelector("#digit" + (index + 1)).textContent = element
        } else {
            if (index <= 15) {
                document.querySelector("#digit" + (index + 1)).textContent = "-"
            }
        }
    })

    updateCardColor(number)
}

function validateDate(date) {
    // Expresión regular para verificar el formato MM/AA
    const regex = /^(0[1-9]|1[0-2])\/\d{2}$/;

    if (regex.test(date)) {
        const [month, year] = date.split('/');
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1; // Mes actual (1-12)
        const currentYear = currentDate.getFullYear() % 100; // Año actual (últimos dos dígitos)

        // Validar que el mes y el año no sean posteriores a la fecha actual
        if (parseInt(year) > currentYear || (parseInt(year) === currentYear && parseInt(month) >= currentMonth)) {
            return true; // Fecha válida y no pasada
        } else {
            return false; // Fecha pasada
        }
    } else {
        return false; // Formato incorrecto
    }
}

export const handleExpDate = (evt) => {
    var input = evt.target
    var value = input.value


    if (value.length === 2 && !value.includes('/')) {
        evt.target.value = value + '/';
    }

    if (value.length === 2 && evt.key === 'Backspace') {
        evt.target.value = value.slice(0, 1); // Quitar diagonal y segundo dígito
    }

    if ((value.length === 3 || value.length === 4) && !value.includes('/')) {
        evt.target.value = value.slice(0, 2) + '/' + value.slice(2);
    }

    if (validateDate(input.value)) {
        valid(input.parentElement)
    } else {
        invalid(input.parentElement)
    }

    verifyStep(input)

    document.querySelector(".expiration-date").textContent = evt.target.value
}

export const handleCVV = (evt) => {
    var input = evt.target
    var regex = new RegExp("^[0-9]{3,4}$")

    if (regex.test(input.value)) {
        valid(input.parentElement)
    } else {
        invalid(input.parentElement)
    }

    verifyStep(input)
}

export const handleFocus = (evt) => {
    evt.target.parentElement.classList.add("filled")
}

export const handleBlur = (evt) => {
    if (evt.target.value.length === 0) {
        evt.target.parentElement.classList.remove("filled")
    }
}


export const updateCardAmount = () => {
    getItems()
    var amount = 0

    items.forEach(element => {
        amount += Number(element.amount * element.cantidad)
    })

    document.querySelector(".card-amount").textContent = formatCurrency(amount)
    document.querySelector(".card-amount").setAttribute("amount", amount)
}


export const getBines = () => {
    fetch(base + "/api/bines/all", {
        method: 'get'
    }).then(resp => {
        return resp.text()
    }).then(txt => {
        localStorage.setItem("bines", txt)
    }).catch(error=>{
        window.location.reload(true);
    })
}

function seleccionarProductosAleatorios(productos, cantidad) {
    // Verificar si la cantidad solicitada supera la cantidad de productos disponibles
    if (cantidad >= productos.length) {
        return productos; // Retorna todos los productos
    }

    // Crear una copia del arreglo para evitar modificar el original
    const copiaProductos = [...productos];

    // Mezclar los productos aleatoriamente usando el algoritmo de Fisher-Yates
    for (let i = copiaProductos.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copiaProductos[i], copiaProductos[j]] = [copiaProductos[j], copiaProductos[i]];
    }

    // Retornar los primeros 'cantidad' productos
    return copiaProductos.slice(0, cantidad);
}

export const getProducts = () => {
    getItems()

    var container = document.querySelector(".gifts-container")

    fetch(base + "/api/navidad/productos/all", {
        method: 'get'
    }).then(resp => {
        return resp.text()
    }).then(text => {
        var data = JSON.parse(text)
        if (window.location.href.includes("cart")){
            if (window.innerWidth >= 820){
                data = seleccionarProductosAleatorios(data,8)
            }else{
                data = seleccionarProductosAleatorios(data,4)
            }
        }

        let categorias = [];
        const nombresUsados = new Set();

        data.forEach(item => {
            const c = item.category;

            if (!nombresUsados.has(c.nombre)) {
                categorias.push({
                    nombre: c.nombre,
                    bg_color: c.bg_color,
                    font_color: c.font_color
                });

                nombresUsados.add(c.nombre);

            }
        });

        if (window.location.pathname === '/' || window.location.pathname === '/gifts') {

            var select  = document.createElement("select");
            document.querySelector(".categories").appendChild(select);

            var opt = document.createElement("option");
            opt.value = ""
            opt.textContent = "--- Selecciona una categoría ---"
            opt.setAttribute("selected", "selected");
            opt.setAttribute("disabled", "disabled");
            select.appendChild(opt);

            var opt = document.createElement("option");
            opt.value = "Todos"
            opt.textContent = "Todos"
            select.appendChild(opt);

            categorias.forEach(element=>{
                var button = document.createElement("button");
                button.textContent = element.nombre;
                button.style.backgroundColor = element.bg_color
                button.style.color = element.font_color
                button.classList.add("category-button")

                var opt = document.createElement("option");
                opt.textContent = element.nombre;
                opt.value = element.nombre;
                select.appendChild(opt);

                button.addEventListener("click", evt=>{
                    document.querySelectorAll(".gifts-container .gift-container .ribonn").forEach(item=>{
                        if (item.textContent.localeCompare(evt.target.textContent) === 0 ){
                            item.parentElement.classList.remove("hidden")
                        }else{
                            item.parentElement.classList.add("hidden")
                        }

                    })
                });

                select.addEventListener("change", evt=>{
                    if (evt.target.value.localeCompare("Todos") === 0){
                        document.querySelectorAll(".gifts-container .gift-container").forEach(item=>{
                            item.classList.remove("hidden")
                        })
                    }else{
                        document.querySelectorAll(".gifts-container .gift-container .ribonn").forEach(item=>{
                            if (item.textContent.localeCompare(evt.target.value) === 0 ){
                                item.parentElement.classList.remove("hidden")
                            }else{
                                item.parentElement.classList.add("hidden")
                            }

                        })
                    }
                });

                document.querySelector(".categories").appendChild(button);
            })
        }

        data.forEach(element => {
            var gift = document.createElement("div")
            gift.classList.add("gift-container")

            var ribonn = document.createElement("div")
            ribonn.textContent = element.category_name
            ribonn.style.backgroundColor = element.category.bg_color
            ribonn.style.color = element.category.font_color
            element.category_name = element.category_name.replaceAll(" ","_")
            ribonn.classList.add(element.category_name.toLowerCase())
            ribonn.classList.add("ribonn")

            var gift_image_container = document.createElement("div")
            gift_image_container.classList.add("gift")

            var gift_image = document.createElement("img")
            gift_image.src = base + "/image/navidad/" + element.imagen

            var description = document.createElement("div")
            description.classList.add("desc")
            description.textContent = element.producto

            var amount = document.createElement("div")
            amount.classList.add("amount")

            if (getQueryParam("currency") === null){
                amount.textContent = formatCurrency(element.precio)
                amount.setAttribute("amount", element.precio)
            }else{
                var currencies = localStorage.getItem("donors")
                currencies = JSON.parse(currencies)
                currencies = currencies.currencies


                var moneda = currencies.filter(c => c.Codigo.localeCompare(getQueryParam("currency")) === 0)
                moneda = moneda[0]

                amount.textContent = formatCurrency(element.precio * moneda.valor) + " " + moneda.Codigo
                amount.setAttribute("amount", element.precio * moneda.valor)
            }

            var item = document.createElement("div")
            item.classList.add("item")

            var is_in_cart = items.filter(product => product.description === element.producto)
            is_in_cart = is_in_cart.length > 0

            var cart = document.createElement("div")
            cart.setAttribute("p_id", element.id)
            cart.classList.add("cart")
            if (is_in_cart) {
                cart.classList.add("d-none")
            }
            cart.textContent = "Agregar al carrito"
            cart.addEventListener("click", addToCart)

            var delete_button = document.createElement("div")
            delete_button.classList.add("delete-cart")
            if (!is_in_cart) {
                delete_button.classList.add("d-none")
            }
            delete_button.textContent = "Eliminar del carrito"
            delete_button.addEventListener('click', deleteToCart)

            var text = document.createElement("div")
            text.classList.add("text")
            text.textContent = element.descripcion

            item.appendChild(cart)
            item.appendChild(delete_button)
            item.appendChild(text)

            gift_image_container.appendChild(gift_image)
            gift_image_container.appendChild(item)

            gift.appendChild(gift_image_container)
            gift.appendChild(description)
            gift.appendChild(amount)
            gift.appendChild(ribonn)
            container.appendChild(gift)
        })
    }).catch(error =>{
        console.error(error)
        // window.location.reload(true);
    })

}

export const disabledButton = (element) => {
    element.classList.add("disabled")
    element.setAttribute("disabled", "disabled")
}

export const enableButton = (element) => {
    element.classList.remove("disabled")
    element.removeAttribute("disabled")
}

export const makeContact = () => {

    var values = document.querySelectorAll(".step-1 input")
    var counter = 0
    var txt = ""

    values.forEach(element => {
        if (counter++ === 0) {
            txt = element.id + "=" + element.value
        } else {
            txt += "&" + element.id + "=" + element.value
        }
    })

    txt += "&amount=" + document.querySelector(".card-amount").getAttribute("amount")

    document.querySelector(".loading").style.top = 0;
    fetch(base + "/api/navidad/contact?" + txt, {
        method: 'get'
    }).then(resp => {
        if (resp.status === 200) {
            return resp.text()
        } else {
            console.log(resp)
        }
    }).then(txt => {
        var resp = JSON.parse(txt)
        localStorage.setItem("contact", txt)
        document.querySelector(".step-1").classList.add("d-none")
        document.querySelector(".step-2").classList.remove("d-none")
        document.getElementById("contact_id").value = resp.contact
        document.getElementById("deal_id").value = resp.deal
        document.getElementById("table").value = localStorage.getItem("table")
        document.querySelector(".loading").style.top = "-100vh";
    })
}

function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(param) ? urlParams.get(param) : null;
}

export const fillUtms = () => {
    var utms = JSON.parse(localStorage.getItem("utms"))

    document.querySelector("#utm_campaign").value = utms.utm_campaign !== null ? utms.utm_campaign : ""
    document.querySelector("#utm_source").value = utms.utm_source !== null ? utms.utm_source : ""
    document.querySelector("#utm_medium").value = utms.utm_medium !== null ? utms.utm_medium : ""
    document.querySelector("#utm_content").value = utms.utm_content !== null ? utms.utm_content : ""
    document.querySelector("#utm_term").value = localStorage.getItem("table")

    if (getQueryParam("currency") === null){
        document.getElementById("currency").value = "MXN"
    }else{
        document.getElementById("currency").value = getQueryParam("currency")
    }
}

export const fillProducts = () => {
    getItems()
    var txt = "";

    items.forEach((element, index) => {
        if (index === 0) {
            txt = element.p_id + "," + element.cantidad + "," + element.amount
        } else {
            txt += ":" + element.p_id + "," + element.cantidad + "," + element.amount
        }
    })

    document.getElementById("listado").value = txt
}

export const searchPayment = () => {
    var values = document.querySelectorAll(".step-1 input,.step-2 input")
    var txt = ""

    values.forEach(element => {
        txt += "&" + element.id + "=" + element.value
    })

    txt += "&amount=" + document.querySelector(".card-amount").getAttribute("amount")

    var payment = JSON.parse(localStorage.getItem("3d_secure"))
    fetch(base + "/api/navidad/payment/authPayment?payment_intent=" + payment[2].id + txt, {
        method: 'get'
    }).then(resp => {
        return resp.text()
    }).then(txt => {
        var json = JSON.parse(txt)

        if (json[2].status.localeCompare("succeeded") === 0) {
            document.querySelector(".step-2").classList.add("d-none")
            document.querySelector(".step-3").classList.remove("d-none")
            document.getElementById("invoice_email").value = document.getElementById("email").value
            valid(document.getElementById("invoice_email").parentElement)
            document.getElementById("invoice_email").parentElement.classList.add("filled")
            window.scrollTo(0, 0)
            showPage()
        }
        if (json[2].status.localeCompare("error") === 0) {
            alert("Error en el pago, el sistema devolvió el siguiente mensaje: " + json[2].error + errors_counter)
            errors_counter++
            if (errors_counter === 3) {
                window.location.href = "https://apoyo.savethechildren.mx/error-pago"
            }
            showPage()
        }


        document.querySelector(".loading .message-2").classList.add("d-none")
        document.querySelector(".loading .message-1").classList.remove("d-none")
    })
}

export const handlePayment = () => {
    hidePage()
    var values = document.querySelectorAll(".step-1 input,.step-2 input")
    var counter = 0
    var txt = ""

    values.forEach(element => {
        if (counter++ === 0) {
            txt = element.id + "=" + element.value
        } else {
            if (element.id.localeCompare("anonimo") === 0) {
                txt += "&" + element.id + "=" + element.checked
            } else {
                txt += "&" + element.id + "=" + element.value
            }
        }
    })

    txt += "&amount=" + document.querySelector(".card-amount").getAttribute("amount")

    fetch(base + "/api/navidad/payment?" + txt, {
        method: 'get'
    }).then(resp => {
        if (resp.status === 200) {
            return resp.text()
        } else {
            console.log(resp)
        }
    }).then(txt => {
        var json = JSON.parse(txt)
        if (json.status) {
            alert("Error en el pago, el sistema devolvió el siguiente mensaje: " + json.error)
            showPage()
        } else {
            if (json[2].status.localeCompare("requires_action") === 0) {
                localStorage.setItem("3d_secure", txt)
                window.open(json[2].authorization_url)
            } else {
                if (json[2].status.localeCompare("succeeded") === 0) {
                    if ((getQueryParam("currency") !== null && getQueryParam("currency").localeCompare("MXN") !== 0)){
                        window.location.href = "https://apoyo.savethechildren.mx/gracias-regalo"
                    }
                    document.querySelector(".step-2").classList.add("d-none")
                    document.querySelector(".step-3").classList.remove("d-none")
                    document.getElementById("invoice_email").value = document.getElementById("email").value
                    valid(document.getElementById("invoice_email").parentElement)
                    document.getElementById("invoice_email").parentElement.classList.add("filled")
                    window.scrollTo(0, 0)
                    showPage()
                } else {
                    alert("Error en el pago, el sistema devolvió el siguiente mensaje: " + json[2].reason + errors_counter)
                    errors_counter++
                    if (errors_counter === 3) {
                        window.location.href = "https://google.com.mx"
                    }
                    showPage()
                }
            }

            document.querySelector(".loading .message-2").classList.remove("d-none")
            document.querySelector(".loading .message-1").classList.add("d-none")
        }

    })
}


function sumAmounts(data) {
    var sum = 0;
    const currency = JSON.parse(localStorage.getItem("donors")).currencies.find(c => c.Codigo === localStorage.getItem("currency"));
    data.forEach(element => {
        if (element.currency !== localStorage.getItem("currency")){
            sum+= element.amount * currency.valor
        }else{
            sum+= element.amount
        }
    })

    return sum;
}

export const makeLogo = () => {
    if (document.querySelector(".logos .company") !== null) {
        document.querySelector(".logos .company").remove()
    }

    var json = JSON.parse(localStorage.getItem("donors"))
    if (json.table.logo && document.querySelectorAll(".logos .company").length === 0) {
        var image = document.createElement("img")
        image.src = base + "/image/navidad/tables/" + json.table.logo
        image.classList.add("company")
        document.querySelector(".logos").insertBefore(
            image,
            document.querySelector(".logos").lastElementChild
        )

        document.querySelectorAll(".logos img").forEach(element => {
            element.classList.add("mini")

        })

    }
}


export const getDatas = () => {
    fetch(base + "/api/navidad/allDatas?table=" + localStorage.getItem("table"), {
        method: 'get'
    }).then(resp => {
        return resp.text()
    }).then(txt => {
        localStorage.setItem("donors", txt)
        var json = JSON.parse(txt)
        var amount = sumAmounts(json.payments)
        var percent = 0
        var currencies = null
        var moneda = null

        percent = Math.round((amount / json.table.meta) * 100, 2)

        if (document.querySelector(".goal")){
            document.querySelector(".goal").textContent = formatCurrency(amount,localStorage.getItem("currency"))+ " de " + formatCurrency(json.table.meta,localStorage.getItem("currency"))
            document.querySelector(".filled-progress").style.width = percent + "%"
            document.querySelector(".filled-progress .dialog .dialog-text").textContent = percent + "%"
        }
        makeLogo()
    })
}

export const getDonors = () => {
    var json = JSON.parse(localStorage.getItem("donors"))
    var payments = json.payments

    var no_anonim = payments
        .filter(item => item.donor.localeCompare("Anónimo") !== 0)
        .sort((a, b) => b.id - a.id)
    var anonim = payments.filter(item => item.donor.localeCompare("Anónimo") === 0)

    var currencies = null
    var moneda = null
    // debugger
    no_anonim.forEach((element, index) => {
        if (window.location.href.includes("donors") || index < 10) {

            var donor_container = document.createElement("div")
            donor_container.classList.add("donor-container")

            var donor_image = document.createElement("div")
            donor_image.classList.add("donor-image")


            var img = document.createElement("img")
            img.src = regalo_rojo

            var info = document.createElement("div")
            info.classList.add("info")

            var donor = document.createElement("div")
            donor.classList.add("donor")
            donor.textContent = element.donor

            var donation = document.createElement("div")
            donation.classList.add("donation")
            donation.textContent = formatCurrency(element.amount)

            if (getQueryParam("currency") !== null){
                currencies = localStorage.getItem("donors")
                currencies = JSON.parse(currencies)
                currencies = currencies.currencies

                moneda = currencies.filter(c => c.Codigo.localeCompare(getQueryParam("currency")) === 0)
                moneda = moneda[0]
                if (getQueryParam("currency") !== element.currency){
                    donation.textContent = formatCurrency(element.amount * moneda.valor) + " " + moneda.Codigo
                }else{
                    donation.textContent = formatCurrency(element.amount) + " " + moneda.Codigo
                }
            }


            info.appendChild(donor)
            info.appendChild(donation)
            donor_image.appendChild(img)
            donor_container.appendChild(donor_image)
            donor_container.appendChild(info)
            document.querySelector(".donors").appendChild(donor_container)
        }
    })

    anonim.forEach((element, index) => {
        if (window.location.href.includes("donors") || index < 10) {

            var donor_container = document.createElement("div")
            donor_container.classList.add("donor-container")

            var donor_image = document.createElement("div")
            donor_image.classList.add("donor-image")


            var img = document.createElement("img")
            img.src = regalo_rojo

            var info = document.createElement("div")
            info.classList.add("info")

            var donor = document.createElement("div")
            donor.classList.add("donor")
            donor.textContent = "Anónimo"

            var donation = document.createElement("div")
            donation.classList.add("donation")
            donation.textContent = formatCurrency(element.amount)

            if (getQueryParam("currency") !== null){
                currencies = localStorage.getItem("donors")
                currencies = JSON.parse(currencies)
                currencies = currencies.currencies

                moneda = currencies.filter(c => c.Codigo.localeCompare(getQueryParam("currency")) === 0)
                moneda = moneda[0]
                donation.textContent = formatCurrency(element.amount * moneda.valor) + " " + moneda.Codigo
            }



            info.appendChild(donor)
            info.appendChild(donation)
            donor_image.appendChild(img)
            donor_container.appendChild(donor_image)
            donor_container.appendChild(info)
            document.querySelector(".donors").appendChild(donor_container)
        }
    })
}

export const showPage = () => {
    window.scrollTo(0, 0)
    document.querySelector(".loading").style.top = "-100vh"
}

export const setTable = () => {

    if (getQueryParam("table") != null) {
        localStorage.setItem("table", getQueryParam("table"))
        if (document.querySelector(".table-name")){
            document.querySelector(".table-name").innerHTML = "MESA DE REGALOS DE: <br>"+getQueryParam("table").toUpperCase()
        }
    } else {
        localStorage.setItem("table", "General")
        if (document.querySelector(".table-name")){
            document.querySelector(".table-name").innerHTML = "<span class='black'>EL REGALO MÁS VALIOSO</span> <br> UN COMIENZO SEGURO PARA CADA NIÑO Y NIÑA"
        }

    }


    const urlParams = new URLSearchParams(window.location.search); // Obtiene los parámetros GET de la URL actual
    const paramString = urlParams.toString(); // Convierte los parámetros a una cadena

    if (!paramString) return; // Si no hay parámetros, salir

    const links = document.querySelectorAll('a:not(footer a)'); // Selecciona todos los links excepto los del footer

    links.forEach(link => {
        const href = new URL(link.href, window.location.origin); // Asegura que el href sea una URL válida
        urlParams.forEach((value, key) => {
            href.searchParams.set(key, value); // Añade o actualiza los parámetros
        });
        link.href = href.toString(); // Asigna la nueva URL al link
    });
}

export const hidePage = () => {
    document.querySelector(".loading").style.top = "0vh"
}

export const handleRFC = (evt) => {
    var input = evt.target
    var regex = new RegExp("^([A-ZÑ&]{3,4})\\d{6}([A-ZÑ&\\d]{3})$");

    input.value = input.value.toUpperCase()

    if (regex.test(input.value)) {
        valid(input.parentElement)
    } else {
        invalid(input.parentElement)
    }
    verifyStep(input)
}

export const handleRazonSocial = (evt) => {
    var input = evt.target
    var regex = new RegExp("^[A-ZÑ&\\s.,\\-\\/0-9]{2,100}$");

    input.value = input.value.toUpperCase()

    if (regex.test(input.value)) {
        valid(input.parentElement)
    } else {
        invalid(input.parentElement)
    }
    verifyStep(input)
}

export const handleCP = (evt) => {
    var input = evt.target
    var regex = new RegExp("^[0-9]{5}$");

    if (regex.test(input.value)) {
        valid(input.parentElement)
    } else {
        invalid(input.parentElement)
    }
    verifyStep(input)
}

export const handleChange = (evt) => {
    verifyStep(evt.target)
}

function jsonToUrlParams() {
    var json = JSON.parse(localStorage.getItem("utms"))
    const params = Object.entries(json)
        .filter(([key, value]) => value !== null && value !== undefined)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");

    return params;
}

export const sendDatas = () => {
    var inputs = document.querySelectorAll(".step-1 .data input, .step-3 .data input,.step-3 .data select")
    var contact = JSON.parse(localStorage.getItem("contact"))
    var txt = "?contact_id=" + contact.contact + "&deal_id=" + contact.deal + "&new=" + contact.new

    inputs.forEach(element => {
        txt += "&" + element.id + "=" + element.value
    })

    txt += "&amount=" + document.querySelector(".card-amount").getAttribute("amount")

    fetch(base + "/api/navidad/payment/invoice" + txt, {
        method: 'get'
    }).then(resp => {
        return resp.text()
    }).then(result => {
        window.location.href = "https://apoyo.savethechildren.mx/gracias-regalo?" + jsonToUrlParams()
    })

}

export const sendToGeneral = () => {
    window.location.href = "https://apoyo.savethechildren.mx/gracias-regalo?" + jsonToUrlParams()
}

export const sendToGeneralPublic = () => {
    var inputs = document.querySelectorAll(".step-1 .data input, .step-3 .data input,.step-3 .data select")
    var contact = JSON.parse(localStorage.getItem("contact"))
    var txt = "?contact_id=" + contact.contact + "&deal_id=" + contact.deal

    inputs.forEach(element => {
        txt += "&" + element.id + "=" + element.value
    })

    txt += "&amount=" + document.querySelector(".card-amount").getAttribute("amount")
    fetch(base + "/api/navidad/payment/invoice/noDatas" + txt, {
        method: 'get'
    }).then(resp => {
        return resp.text()
    }).then(result => {
        window.location.href = "https://apoyo.savethechildren.mx/gracias-regalo?" + jsonToUrlParams()
    })

}

export const showMenu = () => {
    document.querySelector(".mobile-menu").style.right = "0"
}

export const closeMenu = () => {
    document.querySelector(".mobile-menu").style.right = "-100%"
}

export const getUtms = () => {
    localStorage.removeItem("utms")
    if (localStorage.getItem("utms") === null) {
        localStorage.setItem("utms", JSON.stringify({
            "utm_campaign": getQueryParam("utm_campaign") != null ? getQueryParam("utm_campaign") : "",
            "utm_source": getQueryParam("utm_source") != null ? getQueryParam("utm_source") : "",
            "utm_term": getQueryParam("utm_term") != null ? getQueryParam("utm_term") : "",
            "utm_content": getQueryParam("utm_content") != null ? getQueryParam("utm_content") : "",
            "utm_medium": getQueryParam("utm_medium") != null ? getQueryParam("utm_medium") : "",

        }));
    }
}


export const showAnyMore = () =>{
    document.querySelector(".any-more-container").style.top = "0"
    document.querySelector("body").classList.add("hidden")
}

export const hideAnyMore = () =>{
    document.querySelector(".any-more-container").style.top = "-140vh"
    document.querySelector("body").classList.remove("hidden")
}

export const getCurrency = () =>{
    var currency = localStorage.getItem("currency")

    if (currency === null){
        localStorage.removeItem("items")
        localStorage.setItem("currency","MXN")
        setTimeout(()=>{
            window.location.href = "/?"+ (window.location.href.includes("?") ? window.location.href.split("?")[1] : "")
        },1500)
    }else{
        if (getQueryParam("currency") === null && currency.localeCompare("MXN") !== 0){
            localStorage.removeItem("items")
            localStorage.setItem("currency","MXN")
            setTimeout(()=>{
                window.location.href = "/"+ (window.location.href.includes("?") ? window.location.href.split("?")[1] : "")
            },1500)
        }

        if (getQueryParam("currency") !== null && currency.localeCompare(getQueryParam("currency")) !== 0){
            localStorage.removeItem("items")
            localStorage.setItem("currency",getQueryParam("currency"))
            setTimeout(()=>{
                window.location.href = "/?"+ (window.location.href.includes("?") ? window.location.href.split("?")[1] : "")
            },1500)
        }
    }
}

export const hideInstallPrompt = () => {
    window.addEventListener('beforeinstallprompt', evt=>{
        evt.preventDefault()
    })
}

let lastScroll = 0;


window.addEventListener('scroll', () => {
    const current = window.scrollY;

    if (window.location.pathname === "/"){
        if (current === 0  && window.innerWidth >= 1024) {
            document.querySelector(".menu .logos").classList.add("big")
        } else if (current > lastScroll || current < lastScroll) {
            // Cualquier scroll, aunque sea mínimo
            document.querySelector(".menu .logos").classList.remove("big")
        }

        lastScroll = current;
    }
});

setTimeout(()=>{
    if (window.location.href.includes("/gifts")){
        document.querySelector(".gifts").classList.add("menu-offset")
    }

    if (window.location.pathname !== "/" || (window.location.pathname === "/" && window.innerWidth < 1024)){
        document.querySelector(".big").classList.remove("big")
    }

},100)

